import axios from 'axios';

let resolveFetchResult = null;
const fetchResultPromise = new Promise(function (resolve, reject) {
  resolveFetchResult = resolve;
});

const store = {
  namespaced: true,
  state: {
    isChatctive: false,
    results: {},
    showSearch: false,
    stamDataLanden: [
      { LandCode: "+31", IsoCode: "NL", Naam: "Nederland" },
      { LandCode: "+32", IsoCode: "BE", Naam: "Belgie" },
      { LandCode: "+49", IsoCode: "DE", Naam: "Duitsland" }
     ],
    stamDataGeslacht: {},
    portalLogo: '/mediq_logo.svg',
    backgroundLogo: null,
    userMarketingPermission: false,
    registrationDetails: {},
    alertMessageDetails: "",
    warehouses: null,
    siteCode: '',
    showOneChildStatus: true,
    materialIds: [],
    cTypeMaterialIds: [],
    fTypeMaterialIds: [],
    cTypeMaterials: false,
    fTypeMaterials: false,
    environment: '',
    notificationsTodos: []
  },
  mutations: {
    setChatStatus(state, payload) {
      state.isChatctive = payload;
    },
    setShowOneChildStatus(state, payload) {
      state.showOneChildStatus = payload;
    },
    setStamDataGeslacht(state, payload) {
      state.stamDataGeslacht = payload;
    },
    setBackgroundLogo(state, payload) {
      state.backgroundLogo = payload.bgImage;
    },
    setUserMarketingPermission(state, payload) {
      state.userMarketingPermission = payload;
    },
    setRegistrationDetails(state, payload) {
      state.registrationDetails = payload.registration;
    },
    setAlertMessageDetails(state, payload) {
      state.alertMessageDetails = payload
    },
    setWarehouses(state, payload) {
      state.warehouses = payload;
    },
    setUserSiteCode(state, payload) {
      state.siteCode = payload;
    },
    setMaterialIds(state, payload) {
      state.materialIds = payload;
    },
    setCTypeMaterialIds(state, payload) {      
      state.cTypeMaterialIds = payload;
    },
    setFTypeMaterialIds(state, payload) {      
      state.fTypeMaterialIds = payload;
    },
    setMaterialTypef(state, payload) {
      state.fTypeMaterials = payload;
    },
    setMaterialTypec(state, payload) {
      state.cTypeMaterials = payload;
    },
    setEnvironment(state, payload) {
      state.environment = payload.environment;
    },
    setNotificationTods(state, payload) {
      state.notificationsTodos = payload;
    }
  },
  actions: {
    updateResults({ commit }, response) {
      resolveFetchResult(response);
      commit('setUserMarketingPermission', response.usermarketingpermission);
      commit('setWarehouses', response.warehouses);
      commit('setUserSiteCode', response.siteCode);
    },
    fetchResults({ commit }) {
      return fetchResultPromise;
    },
    // Not used yet (maybe remove it from the /F34a/Init when necessary)
    fetchStamDataGeslacht({ commit }) {
      return axios.get('StamData/GetGeslachten').then((response) => {
        commit('setStamDataGeslacht', response.data);
      });
    },
    fetchPortalLogo({ commit }) {
      return axios.get('nav/GetPortalDetails').then((response) => {
        commit('setBackgroundLogo', response.data);
        commit('setRegistrationDetails', response.data);
        commit('setEnvironment', response.data);
      });
    },
    fetchWarning ({commit, state}, param) {
      let name = param ? param : 'LoginPageWarning';
      return axios.get('nav/GetLoginWarningMessage?name='+ name).then((response) => {
        if (response && response.data) {
           commit('setAlertMessageDetails', response.data);
        }
      });
    },
    fetchDepotMaterialDetails({ commit }) {
      return axios.get('nav/GetDepotMaterialDetails').then((response) => {
        commit('setMaterialIds', response.data.materialIds);
        commit('setCTypeMaterialIds', response.data.cTypeMaterialIds);
        commit('setFTypeMaterialIds', response.data.fTypeMaterialIds);
        commit('setMaterialTypef', response.data.fTypeMaterialAvailable);
        commit('setMaterialTypec', response.data.cTypeMaterialAvailable);
      });
    }
  },
  getters: {
    getChatStatus(state) {
      return state.isChatctive;
    },
    getShowOneChildStatus: (state) => {
      return state.showOneChildStatus;
    },
    getStamDataLanden: (state) => {
      return state.stamDataLanden;
    },
    getStamDataGeslacht: (state) => {
      return state.stamDataGeslacht;
    },
    getPortalLogo: (state) => {
      return state.portalLogo;
    },
    getBackgroundLogo: (state) => {
      return state.backgroundLogo;
    },
    getUserMarketingPermission: (state) => {
      return state.userMarketingPermission;
    },
    getRegistrationDetails: (state) => {
      return state.registrationDetails;
    },
    getAlertMessageDetails: (state) => {
      return state.alertMessageDetails;
    },
    getWarehouses: (state) => {
      return state.warehouses;
    },
    getSiteCode: (state) => {
      return state.siteCode;
    },
    getMaterialIds: (state) => {      
      return state.materialIds;
    },
    getCTypeMaterialIds: (state) => {
      return state.cTypeMaterialIds;
    },
    getFTypeMaterialIds: (state) => {
      return state.fTypeMaterialIds;
    },
    getCTypeMaterialFlag: (state) => {
      return state.cTypeMaterials;
    },
    getFTypeMaterialFlag: (state) => {
      return state.fTypeMaterials;
    },
    getEnvironment: (state) => {
      return state.environment;
    },
    getNotificationTods(state) {
      return state.notificationsTodos;
    }
  }
};

export default store;
